(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const mediaItems = document.querySelectorAll('.product__media--item');
    const modal = document.querySelector('.product__modal');
    const modalWrapper = document.querySelector('.product__modal--wrapper');
    const modalMediaItems = document.querySelectorAll('.product__modal__media--item');
    const arrowLeft = document.querySelector('.product__modal .arrow-left');
    const arrowRight = document.querySelector('.product__modal .arrow-right');
    let currentIndex = 0;

    function openModal(index) {
      if (modal) modal.style.display = 'flex';
      document.querySelector('html').style.overflow = 'hidden';
      modalMediaItems?.forEach((item, i) => {
        item.style.display = i === index ? 'block' : 'none';
      });
      currentIndex = index;
    }

    function closeModal() {
      modal.style.display = 'none';
      document.querySelector('html').style.overflow = 'auto';
    }

    mediaItems?.forEach((item, i) => {
      item.addEventListener('click', () => {
        openModal(i);
      });
    });

    modal?.addEventListener('click', function (e) {
      if (e.target === modal) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (modal && modal.style.display === 'flex') {
        if (e.key === 'ArrowRight') {
          currentIndex = (currentIndex + 1) % modalMediaItems.length;
          openModal(currentIndex);
        }
        if (e.key === 'ArrowLeft') {
          currentIndex = (currentIndex - 1 + modalMediaItems.length) % modalMediaItems.length;
          openModal(currentIndex);
        }
        if (e.key === 'Escape') {
          closeModal();
        }
      }
    });

    arrowLeft?.addEventListener('click', function (e) {
      e.stopPropagation();
      currentIndex = (currentIndex - 1 + modalMediaItems.length) % modalMediaItems.length;
      openModal(currentIndex);
    });

    arrowRight?.addEventListener('click', function (e) {
      e.stopPropagation();
      currentIndex = (currentIndex + 1) % modalMediaItems.length;
      openModal(currentIndex);
    });

    const swiperThumbs = new Swiper('.swipper-thumbs', {
      spaceBetween: 10,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
    });

    const swiper = new Swiper('.swipper-container', {
      loop: true,
      spaceBetween: 10,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      autoplay: {
        delay: 5000,
      },
      thumbs: {
        swiper: swiperThumbs,
      },
    });
  });
  } catch(e) { console.error(e); }
})();

})();
